"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameScene = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameLayer_1 = require("../Layers/GameLayer");
const DebugLayer_1 = require("../Layers/DebugLayer");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const GameState_1 = require("../Core/GameState");
const GameConfig_1 = require("../Core/GameConfig");
const JudgeManager_Auto_1 = require("../Core/JudgeManager.Auto");
const JudgeManager_1 = require("../Core/JudgeManager");
const MusicManager_1 = require("../Core/MusicManager");
const SoundManager_1 = require("../Core/SoundManager");
const PauseLayer_1 = require("../Layers/PauseLayer");
const FinishScene_1 = require("./FinishScene");
const SceneSwitcher_1 = require("./SceneSwitcher");
const ReadyScene_1 = require("./ReadyScene");
let GameScene = class GameScene extends pixi_js_1.Container {
    constructor(ioc, config, stage, events, switcher) {
        super();
        ioc = ioc.createChild();
        ioc.bind(inversify_1.Container).toConstantValue(ioc);
        ioc.bind(SymbolClasses_1.NoteHelper).toConstantValue(ioc.resolve(SymbolClasses_1.NoteHelper));
        const state = ioc.resolve(GameState_1.GameState);
        ioc.bind(GameState_1.GameState).toConstantValue(state);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const judger = config.autoplay ? ioc.resolve(JudgeManager_Auto_1.AutoJudgeManager) : ioc.resolve(JudgeManager_1.JudgeManager);
        ioc.resolve(MusicManager_1.MusciManager);
        ioc.resolve(SoundManager_1.SoundManager);
        this.addChild(ioc.resolve(GameLayer_1.GameLayer));
        if (config.debug)
            this.addChild(ioc.resolve(DebugLayer_1.DebugLayer));
        let pauseLayer;
        state.on.pause.add(() => {
            pauseLayer = ioc.resolve(PauseLayer_1.PauseLayer);
            this.addChild(pauseLayer);
        });
        state.on.continue.add(() => {
            this.removeChild(pauseLayer);
            pauseLayer.destroy({ children: true });
        });
        state.on.end.add(() => {
            const finish = ioc.resolve(FinishScene_1.FinishScene);
            switcher.switch(this, finish).outEnd.add(remove => {
                this.destroy({ children: true });
                remove();
            });
        });
        state.on.restart.add(() => {
            const ready = ioc.resolve(ReadyScene_1.ReadyScene);
            switcher.switch(this, ready).outEnd.add(remove => {
                this.destroy({ children: true });
                remove();
            });
        });
        state.on.abort.add(() => {
            events.End.emit();
        });
    }
};
GameScene = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [inversify_1.Container, GameConfig_1.GameConfig, SymbolClasses_1.MainStage, SymbolClasses_1.GlobalEvents, SceneSwitcher_1.SceneSwitcher])
], GameScene);
exports.GameScene = GameScene;
//# sourceMappingURL=GameScene.js.map